import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import PollField from "./PollField";

export const PollEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <PollField/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default PollEdit
